import axios from 'axios';

/**
 * 공유 API(백엔드 modules/sharing/shareRouter.js) — 연결·대시보드가 함께 쓴다.
 * @param {string} base `.../sql-developer` 까지의 주소
 */
export function sharesApi(base) {
  const u = `${base}/shares`;
  const enc = encodeURIComponent;
  return {
    searchUsers: (q) => axios.get(`${u}/users`, { params: { q } }).then(r => r.data.data || []),
    connShares: (id) => axios.get(`${u}/connections/${enc(id)}`).then(r => r.data.data || []),
    shareConn: (id, body) => axios.post(`${u}/connections/${enc(id)}`, body).then(r => r.data.data || []),
    dashShares: (tabId) => axios.get(`${base}/monitoring/panels/tabs/${enc(tabId)}/shares`).then(r => r.data.data || []),
    shareDash: (tabId, body) => axios.post(`${base}/monitoring/panels/tabs/${enc(tabId)}/shares`, body).then(r => r.data.data || []),
    incoming: (kinds) => axios.get(`${u}/incoming`, { params: kinds ? { kinds: kinds.join(',') } : {} }).then(r => r.data.data || []),
    accept: (id) => axios.post(`${u}/${id}/accept`).then(r => r.data),
    decline: (id) => axios.post(`${u}/${id}/decline`).then(r => r.data),
    remove: (id) => axios.delete(`${u}/${id}`).then(r => r.data),
    leaveConn: (connId) => axios.delete(`${u}/connections/${enc(connId)}/mine`).then(r => r.data),
  };
}
